// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__VNBX4","label":"Labeled_label__3KDX3","divider":"Labeled_divider__1QXUp"};